import * as React from 'react';
import GaDataStore, { GaData } from '../stores/GaDataStore';

interface GaPushProps {
  triggers: string | string[];
  ga: GaData;
  children: JSX.Element;
}

// DEPRECATED!
// TODO: Remove when GaPush has been removed from all WP pages
class GaPush extends React.Component<GaPushProps> {
  private extendTriggers(child: JSX.Element) {
    const triggers = Array.isArray(this.props.triggers) ? this.props.triggers : [this.props.triggers];

    return triggers.reduce((acc, trigger) => {
      return {
        ...acc,
        [trigger]: (params: any) => {
          if (typeof child.props[trigger] === 'function') {
            GaDataStore.pushWithoutCmsData(this.props.ga);
            child.props[trigger](params);
          } else {
            GaDataStore.pushWithoutCmsData(this.props.ga);
          }
        }
      };
    }, {});
  }

  private enhanceItem(child: JSX.Element): JSX.Element {
    return React.cloneElement(child, { ...this.extendTriggers(child) });
  }

  public render() {
    return React.Children.map(this.props.children, (child) => this.enhanceItem(child as JSX.Element));
  }
}

export default GaPush;
